import { ChatSession } from '@chat/prisma-client';

export interface ChatLink {
  label: string;
  url: string;
}

export interface ChatReply {
  content: string;
  metadata?: Record<string, unknown>;
  // Tappable links the reply carries (e.g. straight to an order/policy
  // page) — kept separate from metadata so a responder implementation
  // doesn't have to know metadata is where chat.service.ts happens to fold
  // it in before persisting (see sendMessage()'s comment).
  links?: ChatLink[];
}

// The swappable seam: chat.service.ts only ever talks to this interface, so
// it never knows whether a reply came from keyword-matching, a direct LLM
// call, or an n8n webhook. Swapping implementations is a provider change in
// chat.module.ts, not a rewrite of the session/message pipeline.
export abstract class ChatResponder {
  abstract readonly key: string;
  abstract respond(session: ChatSession, message: string): Promise<ChatReply>;
}
